






















import {
  Vue, Component, Prop, Watch, Mixins, Emit, PropSync,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import { clone, equals } from 'ramda'
import {
  update, field, collection, get, query, where, set, add, value,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import md5 from 'md5'
import firebase from 'firebase'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import TaskStore from '../../store/modules/tasks'
import { db } from '../../firebase/init'
import { TaskType, CommentType, CustomerType } from '../../types'
import SingleComment from './SingleComment.vue'

function isEmail(text:string) {
  return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(text)
}

@Component({
  components: {
    SingleComment,
  },
})
export default class FindCustomer extends Mixins(MainMixin) {
  @Prop() data!:CommentType[]

  @Prop({ default: '' }) parentRef!:string

  @Prop({ default: true }) showAddNew!:boolean

  blankComment:CommentType = {
    user: this.$store.getters.uid,
    created: new Date(),
    shared: this.$store.getters.multiUser,
    comment: '',
  }

  $refs:any

  comment = clone(this.blankComment)

  loading = false

  async addComment() {
    const valid = await this.$refs.obs.validate()
    if (valid) {
      this.loading = true
      this.comment.created = new Date()
      await db.doc(this.parentRef).update({
        comments: firebase.firestore.FieldValue.arrayUnion(this.comment),
      })
      this.loading = false
      this.comment = clone(this.blankComment)
      this.$refs.obs.reset()
      return this.$toast.success('Comment Added')
    } return ''
  }
}

